import usePrivateAxios from '@/common/api/usePrivateAxios'
import { Mapper } from '@/common/services/mapper'
import { useQuery } from '@tanstack/react-query'

type UseMaintenanceWorkflowsPossibleStatusesProps<T> = {
  mapper?: (data: any) => T
}

export const useMaintenanceWorkflowsPossibleStatuses = <T = Record<string, string>>({
  mapper = Mapper.default<T>(),
}: UseMaintenanceWorkflowsPossibleStatusesProps<T> = {}) => {
  const privateAxios = usePrivateAxios()

  return useQuery({
    queryKey: ['maintenanceWorkflowsPossibleStatuses'],
    queryFn: () => privateAxios.get('/maintenance/workflows/possible_statuses'),
    select: (data: { data: { data: Record<string, string> } }) => mapper(data?.data?.data),
  })
}
